module.exports = __webpack_public_path__ + "img/loading.70392d3b.gif";